import React from 'react';

const SvgBatteryAlert = (props) => (
  <svg
    id="batteryAlert_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 10 10"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    {...props}>
    <style>
      {'.batteryAlert_svg__st1{display:inline}.batteryAlert_svg__st2{fill:red}'}
    </style>
    <g id="batteryAlert_svg__Layer_1_copy">
      <rect x="9.1" y="3.5" width="0.8" height="2.7" fill="currentColor" />
      <path
        className="batteryAlert_svg__st2"
        d="M3.9,1.1C4,1,4,0.9,4.1,0.8s0.1-0.1,0.2-0.1s0.2,0,0.3,0s0.2,0,0.3,0S5,0.8,5.1,0.8S5.2,1,5.2,1.1
		s0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.4s0,0.3-0.1,0.5S5.1,2.8,5.1,3S5,3.6,5,4S4.9,4.8,4.9,5.2s-0.1,1-0.1,1.6H4.4
		c0-0.6-0.1-1.1-0.1-1.6S4.2,4.3,4.2,4S4.1,3.3,4.1,3S4,2.5,4,2.3s0-0.4-0.1-0.5s0-0.3,0-0.4C3.9,1.3,3.9,1.2,3.9,1.1z"
      />
      <path
        className="batteryAlert_svg__st2"
        d="M5.3,8.9C5.3,9,5.2,9,5.2,9.1S5,9.2,4.9,9.3S4.7,9.3,4.6,9.3s-0.2,0-0.3-0.1S4.1,9.2,4,9.1S3.9,9,3.8,8.9
		S3.8,8.7,3.8,8.5s0-0.2,0.1-0.3S3.9,8,4,8c0.1-0.1,0.2-0.1,0.3-0.2s0.2-0.1,0.3-0.1s0.2,0,0.3,0.1S5.1,7.9,5.2,8
		C5.2,8,5.3,8.1,5.3,8.2s0.1,0.2,0.1,0.3S5.4,8.8,5.3,8.9z"
      />
      <path
        d="M5.3,8.9C5.3,9,5.2,9,5.2,9.1S5,9.2,4.9,9.3S4.7,9.3,4.6,9.3s-0.2,0-0.3-0.1S4.1,9.2,4,9.1S3.9,9,3.8,8.9S3.8,8.7,3.8,8.5
		s0-0.2,0.1-0.3S3.9,8,4,8c0.1-0.1,0.2-0.1,0.3-0.2s0.2-0.1,0.3-0.1s0.2,0,0.3,0.1S5.1,7.9,5.2,8C5.2,8,5.3,8.1,5.3,8.2
		s0.1,0.2,0.1,0.3S5.4,8.8,5.3,8.9z"
        fill="currentColor"
      />
      <g>
        <path
          d="M8.5,2.5H5.8L5.6,7.1l3,0.1c0.3,0,0.6-0.3,0.6-0.6V3.1C9.1,2.8,8.8,2.5,8.5,2.5z"
          fill="currentColor"
        />
        <path
          d="M3.2,2.5H0.6c-0.3,0-0.6,0.3-0.6,0.6v3.6c0,0.3,0.3,0.6,0.6,0.6h2.8L3.2,2.5z"
          fill="currentColor"
        />
      </g>
      <path
        d="M3.9,1.1C4,1,4,0.9,4.1,0.8s0.1-0.1,0.2-0.1s0.2,0,0.3,0s0.2,0,0.3,0S5,0.8,5.1,0.8S5.2,1,5.2,1.1s0.1,0.2,0.1,0.4
		c0,0.1,0,0.2,0,0.4s0,0.3-0.1,0.5S5.1,2.8,5.1,3S5,3.6,5,4S4.9,4.8,4.9,5.2s-0.1,1-0.1,1.6H4.4c0-0.6-0.1-1.1-0.1-1.6
		S4.2,4.3,4.2,4S4.1,3.3,4.1,3S4,2.5,4,2.3s0-0.4-0.1-0.5s0-0.3,0-0.4C3.9,1.3,3.9,1.2,3.9,1.1z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default SvgBatteryAlert;
